// extracted by mini-css-extract-plugin
module.exports = {"root":"_1b4c7e","left":"_20db7d","right":"_ead432","amount":"_802e92","number":"_529cc2","tag":"_b78ef0","tags":"_e873a5","free":"_868b82","details":"_83213b"};